import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA4iDYYLSnswXQLqgLcI48MD69nlXBCmhg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ravnyxstorage-6050e.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ravnyxstorage-6050e",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ravnyxstorage-6050e.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "92766274293",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:92766274293:web:efe1e5b288a7ef06bc7bbc",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-RDN1NRPCSL",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
let analytics = null;

if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {});
}

export { app, auth, googleProvider, analytics };
